/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { financingSourcesUnblockWkCreate } from '../fn/working-capitals/financing-sources-unblock-wk-create';
import { financingSourcesUnblockWkCreate$FormData } from '../fn/working-capitals/financing-sources-unblock-wk-create-form-data';
import { FinancingSourcesUnblockWkCreate$FormData$Params } from '../fn/working-capitals/financing-sources-unblock-wk-create-form-data';
import { FinancingSourcesUnblockWkCreate$Params } from '../fn/working-capitals/financing-sources-unblock-wk-create';
import { financingSourcesUnblockWkCreate$XWwwFormUrlencoded } from '../fn/working-capitals/financing-sources-unblock-wk-create-x-www-form-urlencoded';
import { FinancingSourcesUnblockWkCreate$XWwwFormUrlencoded$Params } from '../fn/working-capitals/financing-sources-unblock-wk-create-x-www-form-urlencoded';
import { financingSourcesWorkingCapitalParametersCopyCreate } from '../fn/working-capitals/financing-sources-working-capital-parameters-copy-create';
import { FinancingSourcesWorkingCapitalParametersCopyCreate$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-copy-create';
import { financingSourcesWorkingCapitalParametersCreate } from '../fn/working-capitals/financing-sources-working-capital-parameters-create';
import { financingSourcesWorkingCapitalParametersCreate$FormData } from '../fn/working-capitals/financing-sources-working-capital-parameters-create-form-data';
import { FinancingSourcesWorkingCapitalParametersCreate$FormData$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-create-form-data';
import { FinancingSourcesWorkingCapitalParametersCreate$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-create';
import { financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded } from '../fn/working-capitals/financing-sources-working-capital-parameters-create-x-www-form-urlencoded';
import { FinancingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-create-x-www-form-urlencoded';
import { financingSourcesWorkingCapitalParametersDestroy } from '../fn/working-capitals/financing-sources-working-capital-parameters-destroy';
import { FinancingSourcesWorkingCapitalParametersDestroy$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-destroy';
import { financingSourcesWorkingCapitalParametersList } from '../fn/working-capitals/financing-sources-working-capital-parameters-list';
import { FinancingSourcesWorkingCapitalParametersList$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-list';
import { financingSourcesWorkingCapitalParametersPartialUpdate } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update';
import { financingSourcesWorkingCapitalParametersPartialUpdate$FormData } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update-form-data';
import { FinancingSourcesWorkingCapitalParametersPartialUpdate$FormData$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update-form-data';
import { FinancingSourcesWorkingCapitalParametersPartialUpdate$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update';
import { financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update-x-www-form-urlencoded';
import { FinancingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-partial-update-x-www-form-urlencoded';
import { financingSourcesWorkingCapitalParametersRetrieve } from '../fn/working-capitals/financing-sources-working-capital-parameters-retrieve';
import { FinancingSourcesWorkingCapitalParametersRetrieve$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-retrieve';
import { financingSourcesWorkingCapitalParametersUpdate } from '../fn/working-capitals/financing-sources-working-capital-parameters-update';
import { financingSourcesWorkingCapitalParametersUpdate$FormData } from '../fn/working-capitals/financing-sources-working-capital-parameters-update-form-data';
import { FinancingSourcesWorkingCapitalParametersUpdate$FormData$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-update-form-data';
import { FinancingSourcesWorkingCapitalParametersUpdate$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-update';
import { financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded } from '../fn/working-capitals/financing-sources-working-capital-parameters-update-x-www-form-urlencoded';
import { FinancingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Params } from '../fn/working-capitals/financing-sources-working-capital-parameters-update-x-www-form-urlencoded';
import { BackendIdDto } from '../models/backend-id-dto';
import { BackendWorkingCapitalParameterDto } from '../models/backend-working-capital-parameter-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiWorkingCapitalsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financingSourcesUnblockWkCreate()` */
  static readonly FinancingSourcesUnblockWkCreatePath = '/api/financing_sources/unblock-wk/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockWkCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockWkCreate$Response(
    params: FinancingSourcesUnblockWkCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockWkCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockWkCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockWkCreate(
    params: FinancingSourcesUnblockWkCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockWkCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockWkCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockWkCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesUnblockWkCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockWkCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockWkCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockWkCreate$XWwwFormUrlencoded(
    params: FinancingSourcesUnblockWkCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockWkCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockWkCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockWkCreate$FormData$Response(
    params: FinancingSourcesUnblockWkCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockWkCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockWkCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockWkCreate$FormData(
    params: FinancingSourcesUnblockWkCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockWkCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersList()` */
  static readonly FinancingSourcesWorkingCapitalParametersListPath =
    '/api/financing_sources/working_capital_parameters/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersList$Response(
    params?: FinancingSourcesWorkingCapitalParametersList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendWorkingCapitalParameterDto>>> {
    return financingSourcesWorkingCapitalParametersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersList(
    params?: FinancingSourcesWorkingCapitalParametersList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendWorkingCapitalParameterDto>> {
    return this.financingSourcesWorkingCapitalParametersList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendWorkingCapitalParameterDto>>): Array<BackendWorkingCapitalParameterDto> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersCreate()` */
  static readonly FinancingSourcesWorkingCapitalParametersCreatePath =
    '/api/financing_sources/working_capital_parameters/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersCreate$Response(
    params: FinancingSourcesWorkingCapitalParametersCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersCreate(
    params: FinancingSourcesWorkingCapitalParametersCreate$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded(
    params: FinancingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersCreate$FormData$Response(
    params: FinancingSourcesWorkingCapitalParametersCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersCreate$FormData(
    params: FinancingSourcesWorkingCapitalParametersCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersRetrieve()` */
  static readonly FinancingSourcesWorkingCapitalParametersRetrievePath =
    '/api/financing_sources/working_capital_parameters/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersRetrieve$Response(
    params: FinancingSourcesWorkingCapitalParametersRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersRetrieve(
    params: FinancingSourcesWorkingCapitalParametersRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersUpdate()` */
  static readonly FinancingSourcesWorkingCapitalParametersUpdatePath =
    '/api/financing_sources/working_capital_parameters/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersUpdate$Response(
    params: FinancingSourcesWorkingCapitalParametersUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersUpdate(
    params: FinancingSourcesWorkingCapitalParametersUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersUpdate$FormData$Response(
    params: FinancingSourcesWorkingCapitalParametersUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersUpdate$FormData(
    params: FinancingSourcesWorkingCapitalParametersUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersDestroy()` */
  static readonly FinancingSourcesWorkingCapitalParametersDestroyPath =
    '/api/financing_sources/working_capital_parameters/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersDestroy$Response(
    params: FinancingSourcesWorkingCapitalParametersDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesWorkingCapitalParametersDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersDestroy(
    params: FinancingSourcesWorkingCapitalParametersDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesWorkingCapitalParametersDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersPartialUpdate()` */
  static readonly FinancingSourcesWorkingCapitalParametersPartialUpdatePath =
    '/api/financing_sources/working_capital_parameters/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate$Response(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded(
      this.http,
      this.rootUrl,
      params,
      context,
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate$FormData$Response(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
    return financingSourcesWorkingCapitalParametersPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesWorkingCapitalParametersPartialUpdate$FormData(
    params: FinancingSourcesWorkingCapitalParametersPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendWorkingCapitalParameterDto> {
    return this.financingSourcesWorkingCapitalParametersPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendWorkingCapitalParameterDto>): BackendWorkingCapitalParameterDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesWorkingCapitalParametersCopyCreate()` */
  static readonly FinancingSourcesWorkingCapitalParametersCopyCreatePath =
    '/api/financing_sources/working_capital_parameters/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesWorkingCapitalParametersCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersCopyCreate$Response(
    params: FinancingSourcesWorkingCapitalParametersCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesWorkingCapitalParametersCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesWorkingCapitalParametersCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesWorkingCapitalParametersCopyCreate(
    params: FinancingSourcesWorkingCapitalParametersCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesWorkingCapitalParametersCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
